import { useState } from "react";
import {
  Box,
  Grid,
  Typography,
  useMediaQuery,
  Theme,
  Avatar,
  styled,
  Tabs,
  Tab,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import {
  ShowBase,
  useRecordContext,
} from "react-admin";
import { useNotify } from "react-admin";

import ComponentShow, {
  ShowActions,
} from "../../../components/PageComponents/ComponentShow";
import { formatDate, linkAmount } from "../../../utils/paymentFormat";
import SummaryTab from "./SummaryTab";
import CustomerTab from "./CustomerTab";
import QuickView from "./QuickView";
import DetailHeader from "../../../components/PageComponents/DetailHeader";
import { StatusLabel } from "../../../components/Label/status";
import { linkCurrencyLabel } from "./linkCurrency";

const PaymentLinkShow = () => {
  return (
    <ShowBase>
      <Content />
    </ShowBase>
  );
};

const Content = () => {
  const record = useRecordContext();
  if (!record) return null;

  return (
    <ComponentShow
      header={
        <DetailHeader
          kind="Payment link"
          title={linkAmount(record.params)}
          status={<StatusLabel statusField="statusPaymentLink" />}
          facts={[record.internalRef && `Ref. ${record.internalRef}`, linkCurrencyLabel(record.params?.currency, (key) => key) && `Pay in ${linkCurrencyLabel(record.params?.currency, (key) => key)}`, `Expires ${formatDate(record.expiresAt)}`]}
        />
      }
    >
      <ContentShow />
    </ComponentShow>
  );
};

const ContentShow = () => {
  const { t }: { t: any } = useTranslation();
  const isMobile = useMediaQuery<Theme>((theme) =>
    theme.breakpoints.down("sm")
  );
  const [currentTab, setCurrentTab] = useState<string>("summary");

  const handleTabsChange = (_event: React.SyntheticEvent, value: string) => {
    setCurrentTab(value);
  };

  // 📱 Mobile view
  if (isMobile) {
    return (
      <Box sx={{ px: 2, mt: 2, mb: 4 }}>
        <Box sx={{ display: "flex", justifyContent: "flex-end", mb: 2 }}>
          <ShowActions resource="paymentLinks" />
        </Box>
        <Typography variant="h6" fontWeight="bold" sx={{ mb: 2 }}>
          {t("Summary")}
        </Typography>
        <SummaryTab />
        <Typography variant="h6" fontWeight="bold" sx={{ mt: 4, mb: 2 }}>
          {t("Customer")}
        </Typography>
        <CustomerTab />
        <Box sx={{ mt: 4 }}>
          <QuickView />
        </Box>
      </Box>
    );
  }

  // 🖥️ Desktop view
  return (
    <Box sx={{ mt: 3, mb: 4 }}>
      <Grid
        container
        direction="row"
        justifyContent="center"
        spacing={4}
        sx={{ px: 4 }}
      >
        <Grid item xs={9} md={9}>
          <Tabs
            value={currentTab}
            onChange={handleTabsChange}
            variant="scrollable"
            scrollButtons="auto"
            textColor="primary"
            indicatorColor="primary"
            sx={{ mb: 2 }}
          >
            <Tab value="summary" label={t("Summary")} />
            <Tab value="customer" label={t("Customer")} />
          </Tabs>
        </Grid>
        <Grid
          item
          xs={3}
          md={3}
          sx={{ display: "flex", justifyContent: "flex-end" }}
        >
          <ShowActions resource="paymentLinks" />
        </Grid>
        <Grid item xs={12} md={8}>
          {currentTab === "summary" && <SummaryTab />}
          {currentTab === "customer" && <CustomerTab />}
        </Grid>
        <Grid item xs={12} md={4}>
          <QuickView />
        </Grid>
      </Grid>
    </Box>
  );
};

export default PaymentLinkShow;
